export enum Path {
  Home = "/",
  About = "/about",
  Practice = "/practice",
  PracticeUnit = "/practice/:unitId",
  Translate = "/translate",
  SpellingLetters = "/games/SpellingLetters",
  SpellingWords = "/games/SpellingWords",
  HangMan = "/games/HangMan",
  Wordle = "/games/Wordle",
  AlphabetQuiz = "/games/AlphabetQuiz",
  MemoryMatch = "/games/MemoryMatch",
  SpeedSign = "/games/SpeedSign",
  NumberSigns = "/games/NumberSigns",
  FillInBlank = "/games/FillInBlank",
  SignBingo = "/games/SignBingo",
  Games = "/games",
  //Leaderboard = "/leaderboard",
  // Profile = "/profile",
  // SignIn = "/signin",
  // SignUp = "/signup",
  HandSigns = "/handSigns",
  // ForgotPasswordID = "/forgot-password/:id",
  // ForgotPassword = "/forgot-password",
}
